<template>
  <div class="pt-3">
    <v-row no-gutters v-if="dataSet && !loading">
      <v-col cols="12" md="8">
        <div class="pa-3">
          <v-card class="rounded-lg mb-3" flat>
            <v-img
              :src="dataSet.cover_picture ? dataSet.cover_picture : dummy_cover"
              height="230px"
              class="obj_fit pa-1"
            >
              <div class="d-flex justify-space-between">
                <v-btn
                  color="#fff"
                  fab
                  x-small
                  depressed
                  @click="$router.go(-1)"
                >
                  <v-icon>mdi-undo</v-icon>
                </v-btn>

                <v-btn
                  v-if="permissions.includes('UPCM') || role == 'SUPERADMIN'"
                  color="blue"
                  depressed
                  dark
                  small
                  @click="$refs.cover.click()"
                >
                  <input
                    ref="cover"
                    type="file"
                    @change="uploadCover($event)"
                    accept="image/*"
                    class="input_hide"
                  />
                  <v-icon small>mdi-pencil</v-icon>
                  Edit Cover Photo
                </v-btn>
              </div>
            </v-img>

            <div class="pa-3">
              <div style="position: relative">
                <div style="position: absolute; z-index: 3; left: 110px">
                  <v-btn
                    v-if="permissions.includes('UPCM') || role == 'SUPERADMIN'"
                    color="blue"
                    depressed
                    fab
                    dark
                    x-small
                    @click="$refs.file.click()"
                  >
                    <input
                      ref="file"
                      type="file"
                      @change="uploadImage($event)"
                      accept="image/*"
                      class="input_hide"
                    />
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
                <img
                  :src="
                    dataSet.profile_picture
                      ? dataSet.profile_picture
                      : dummy_ava
                  "
                  height="130px"
                  width="130px"
                  class="obj_fit rounded-lg"
                  style="margin-top: -100px; z-index: 2; position: relative"
                  alt=""
                />
              </div>

              <h3>{{ dataSet.name }}</h3>
              <div class="_70_w">
                <b class="color_default small_txt">{{
                  dataSet.address ? dataSet.address : "-"
                }}</b>
                <p class="default_txt mt-2">
                  Sector :
                  {{ dataSet.data_sector ? dataSet.data_sector.name : "-" }}
                </p>
              </div>
            </div>
          </v-card>
          <v-card class="rounded-lg pa-3 mb-3" flat>
            <v-row>
              <v-col cols="12" md="9">
                <h3 class="color_default">About Institution</h3>
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex justify-end">
                  <v-btn
                    v-if="permissions.includes('UPCM') || role == 'SUPERADMIN'"
                    icon
                    small
                    color="blue"
                    @click="updateData('about')"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <p v-if="dataSet.about" v-html="dataSet.about" class="mt-2"></p>
            <p v-else class="mt-2">-</p>
          </v-card>
          <v-card class="rounded-lg pa-3 mb-3" flat>
            <contact-person-up />
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="pa-3">
          <v-card class="rounded-lg pa-3 mb-5" flat>
            <div class="mb-5">
              <v-row>
                <v-col cols="12" md="9">
                  <h3 class="color_default">Vision</h3>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="d-flex justify-end">
                    <v-btn
                      v-if="permissions.includes('UPCM') || role == 'SUPERADMIN'"
                      icon
                      small
                      color="blue"
                      @click="updateData('vision')"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <p v-if="dataSet.vision" v-html="dataSet.vision" class="mt-2"></p>
              <p v-else class="mt-2">-</p>
            </div>
            <div class="mb-5">
              <v-row>
                <v-col cols="12" md="9">
                  <h3 class="color_default">Mission</h3>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="d-flex justify-end">
                    <v-btn
                      v-if="permissions.includes('UPCM') || role == 'SUPERADMIN'"
                      icon
                      small
                      color="blue"
                      @click="updateData('mission')"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <p
                v-if="dataSet.mission"
                v-html="dataSet.mission"
                class="mt-2"
              ></p>
              <p v-else class="mt-2">-</p>
            </div>
          </v-card>
          <v-card class="rounded-lg pa-3 mb-5" flat>
            <v-row>
              <v-col cols="12" md="9">
                <h3 class="color_default">Contact</h3>
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex justify-end">
                  <v-btn
                    v-if="permissions.includes('UPCM') || role == 'SUPERADMIN'"
                    icon
                    small
                    color="blue"
                    @click="updateContact(dataSet)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <div class="mt-5">
              <div v-for="(item, i) in contact" :key="i">
                <div class="mb-3" v-if="dataSet[item]">
                  <v-icon class="mr-2" color="var(--g)"
                    >mdi-{{ item == "phone_number" ? "phone" : item }}</v-icon
                  >
                  {{ dataSet[item] }}
                </div>
              </div>
            </div>
          </v-card>
          <v-card class="rounded-lg pa-3 mb-3" flat>
            <event-up />
          </v-card>
        </div>
      </v-col>
    </v-row>
    <div v-if="loading">
      <loading-lg />
    </div>
    <div class="pa-3">
      <dialog-up
        :d_up="d_up"
        @refetch="fetchData"
        @close="d_up = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        :width="d_width"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ContactPersonUp from "./contactPersonUp.vue";
import DialogUp from "./dialogUp.vue";
import EventUp from "./eventUp.vue";
export default {
  name: "detilUp",
  components: { DialogUp, ContactPersonUp, EventUp },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      dummy_cover: require("../../assets/img/build_cover.jpg"),
      dummy_ava: require("../../assets/img/company_default.png"),
      loading: false,
      d_up: false,
      d_width: "450px",
      inventory: null,
      d_type: "",
      d_title: "",
      dataSet: null,
      find: "",
      contact: [
        "email",
        "phone_number",
        "instagram",
        "youtube",
        "facebook",
        "twitter",
        "linkedin",
      ],
      image: {
        src: "",
        type: "image/jpg",
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `univ-partner?filter[id]=${this.$route.params.id}&include=dataSector`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data[0];
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    updateContact(item) {
      this.inventory = {
        id: item.id,
        email: item.email,
        phone_number: item.phone_number,
        instagram: item.instagram,
        youtube: item.youtube,
        facebook: item.facebook,
        twitter: item.twitter,
        linkedin: item.linkedin,
      };

      this.d_title = "Edit Contact";
      this.d_type = "up_medsos";
      this.d_up = true;
    },
    updateData(key) {
      this.inventory = { id: this.dataSet.id };
      this.inventory[key] = this.dataSet[key];
      this.inventory["type"] = key;
      this.d_width = "50%";
      this.d_title = `Update ${key}`;
      this.d_type = "up_txt";
      this.d_up = true;
    },

    // CROP STUFF
    uploadImage(event) {
      /// Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. Update the image. The type will be derived from the extension and it can lead to an incorrect result:
        this.image = {
          src: blob,
          type: files[0].type,
        };
        this.showCrop();
      }
    },
    showCrop() {
      this.d_type = "crop";
      this.d_title = "Change profile picture UP";
      this.inventory = this.image;
      this.d_up = true;
      this.d_width = "450px";
    },
    uploadCover(event) {
      /// Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. Update the image. The type will be derived from the extension and it can lead to an incorrect result:
        this.image = {
          src: blob,
          type: files[0].type,
        };
        this.showCropCover();
      }
    },
    showCropCover() {
      this.d_type = "crop_cover";
      this.d_title = "Change Cover picture UP";
      this.inventory = this.image;
      this.d_up = true;
      this.d_width = "450px";
    },
  },
};
</script>

<style scoped>
.input_green {
  border: 2px solid var(--g);
  border-radius: 5px;
  padding: 0 0 0 30px;
  height: 38px;
  background: #fff;
  width: 100%;
}
.input_green:focus {
  outline: none;
}
.magnify {
  margin-right: -30px;
}
.button-wrapper {
  display: flex;
  justify-content: center;
}
.input_hide {
  display: none;
}
</style>
